/**
 * WooCommerce Cart Event Links
 * Makes event titles in the cart clickable to navigate to event pages
 */

const cartEventLinks = {
	/**
	 * Make event titles clickable in the cart
	 */
	makeEventTitlesClickable() {
		// Find all event details in the cart
		const eventDetails = document.querySelectorAll('.wc-block-components-product-details__event');
		
		// Debug logging for checkout page
		if (window.location.pathname.includes('checkout')) {
			console.log('Looking for event details on checkout, found:', eventDetails.length);
		}
		
		// Convert NodeList to Array for better compatibility
		const eventDetailsArray = Array.from(eventDetails);
		
		eventDetailsArray.forEach((eventDetail) => {
			const eventValue = eventDetail.querySelector('.wc-block-components-product-details__value');
			if (eventValue && !eventValue.classList.contains('event-link-processed')) {
				const eventTitle = eventValue.textContent.trim();
				
				// Get the product row to find the associated event
				// Try cart selector first, then checkout selector
				const productRow = eventDetail.closest('.wc-block-cart-items__row') || 
								  eventDetail.closest('.wc-block-components-order-summary-item');
				
				// On checkout, product name is directly in the item, on cart it might be nested
				const productName = productRow ? 
					(productRow.querySelector('.wc-block-components-product-name') || 
					 productRow.querySelector('h3.wc-block-components-product-name')) : null;
				
				// Proceed if we found a product context (either cart or checkout)
				if (productRow) {
					// Style the event title as a link
					eventValue.style.textDecoration = 'underline';
					eventValue.style.cursor = 'pointer';
					eventValue.style.color = '#0073aa'; // Add link color
					eventValue.title = 'Click to view event details';
					
					// Add hover effect
					eventValue.addEventListener('mouseenter', () => {
						eventValue.style.textDecoration = 'underline';
						eventValue.style.opacity = '0.8';
					});
					
					eventValue.addEventListener('mouseleave', () => {
						eventValue.style.textDecoration = 'underline';
						eventValue.style.opacity = '1';
					});
					
					// Add click event
					eventValue.addEventListener('click', () => {
						let eventUrl = null;
						
						// Normalize the title to handle different dash types
						const normalizedTitle = eventTitle
							.replace(/—/g, '-')  // Replace em dash with regular dash
							.replace(/–/g, '-')  // Replace en dash with regular dash
							.replace(/\s+/g, ' '); // Normalize spaces
						
						// First try to get URL from the global object with exact match
						if (window.eventTicketUrls && window.eventTicketUrls[eventTitle]) {
							eventUrl = window.eventTicketUrls[eventTitle];
						} 
						// Try with normalized title
						else if (window.eventTicketUrls && window.eventTicketUrls[normalizedTitle]) {
							eventUrl = window.eventTicketUrls[normalizedTitle];
						}
						// Try to find a partial match in the global object
						else if (window.eventTicketUrls) {
							// Loop through all stored URLs to find a match
							for (const [storedTitle, url] of Object.entries(window.eventTicketUrls)) {
								const normalizedStoredTitle = storedTitle
									.replace(/—/g, '-')
									.replace(/–/g, '-')
									.replace(/\s+/g, ' ');
								
								if (normalizedStoredTitle === normalizedTitle) {
									eventUrl = url;
									break;
								}
							}
						}
						
						// Fallback: Look for the span with data-event-url inside eventValue
						if (!eventUrl) {
							const eventSpan = eventValue.querySelector('span[data-event-url]');
							
							if (eventSpan) {
								// Found the span with the URL
								eventUrl = eventSpan.getAttribute('data-event-url');
							} else if (eventValue.getAttribute('data-event-url')) {
								// Check if the attribute is directly on eventValue
								eventUrl = eventValue.getAttribute('data-event-url');
							}
						}
						
						if (eventUrl) {
							window.location.href = eventUrl; // Navigate to the event page
						} else {
							// Debug: log what we're seeing
							console.log('Event clicked but no URL found');
							console.log('Looking for:', eventTitle);
							console.log('Normalized:', normalizedTitle);
							console.log('Available URLs:', window.eventTicketUrls);
						}
					});
					
					// Mark as processed
					eventValue.classList.add('event-link-processed');
				}
			}
		});
	},

	/**
	 * Initialize the cart event links functionality
	 */
	init() {
		// Run when page loads
		this.makeEventTitlesClickable();

		// Run when cart updates (for dynamic cart blocks)
		document.addEventListener('updated_wc_div', () => this.makeEventTitlesClickable());

		// Also run on any DOM changes (for React-based cart blocks)
		if (window.MutationObserver) {
			const observer = new MutationObserver((mutations) => {
				let shouldUpdate = false;
				mutations.forEach((mutation) => {
					if (mutation.addedNodes.length > 0) {
						// Convert NodeList to Array
						const addedNodes = Array.from(mutation.addedNodes);
						addedNodes.forEach((node) => {
							if (node.nodeType === 1 && (
								(node.querySelector && node.querySelector('.wc-block-components-product-details__event')) ||
								(node.classList && node.classList.contains('wc-block-components-product-details__event')) ||
								(node.querySelector && node.querySelector('.wc-block-components-order-summary-item')) ||
								(node.classList && node.classList.contains('wc-block-components-order-summary-item')) ||
								(node.querySelector && node.querySelector('.wc-block-components-checkout-order-summary__content')) ||
								(node.classList && node.classList.contains('wc-block-components-checkout-order-summary__content'))
							)) {
								shouldUpdate = true;
							}
						});
					}
				});
				if (shouldUpdate) {
					setTimeout(() => this.makeEventTitlesClickable(), 100);
				}
			});
			
			observer.observe(document.body, {
				childList: true,
				subtree: true
			});
		}
		
		// Special handling for checkout page - wait for React to finish rendering
		if (window.location.pathname.includes('checkout')) {
			// Try multiple times with delays to catch React rendering
			const attempts = [100, 500, 1000, 2000, 3000];
			attempts.forEach(delay => {
				setTimeout(() => {
					this.makeEventTitlesClickable();
				}, delay);
			});
			
			// Also listen for WooCommerce checkout events
			if (window.jQuery) {
				jQuery(document.body).on('updated_checkout', () => {
					setTimeout(() => this.makeEventTitlesClickable(), 100);
				});
				
				// Listen for when checkout form is fully loaded
				jQuery(document).on('ready', () => {
					setTimeout(() => this.makeEventTitlesClickable(), 500);
				});
			}
		}
	}
};

export default cartEventLinks;